import { Injectable } from '@angular/core';

import { I18nService } from '@localize/services/i18n/i18n.service';

@Injectable({
	providedIn: 'root'
})
export class StaticService {
	private strings = {
		// Languages Portal UI is fully translated into
		languages: [
			{ id: 'en', label: 'English', i18n: 'app.lang.en' }
			// { id: 'de', label: 'Deutsch', i18n: 'app.lang.de' }
		],
		locales: [
			{ id: 'en', label: 'English' },
			{ id: 'de', label: 'Deutsch' },
			{ id: 'fr', label: 'Français' },
			{ id: 'nl', label: 'Nederlands' },
			{ id: 'ja', label: '日本語' },
			{ id: 'it', label: 'Italiano' },
			{ id: 'cs', label: 'Česky' },
			{ id: 'ko', label: '한국어' },
			{ id: 'es', label: 'Español' },
			{ id: 'pt-pt', label: 'Português' },
			{ id: 'pt', label: 'Português (Brazil)' },
			{ id: 'pl', label: 'Polski' },
			{ id: 'ru', label: 'Pусский' },
			{ id: 'th', label: 'ไทย' },
			{ id: 'sl', label: 'Slovenščina' },
			{ id: 'hr', label: 'Hrvatski' },
			{ id: 'id', label: 'Bhaasa Indonesia' },
			{ id: 'zh-hans', label: '英语' },
			{ id: 'zh-hant', label: '繁體中文' }
		],
		genders: [
			{ id: 'male', label: 'Male', i18n: 'app.gender.male' },
			{ id: 'female', label: 'Female', i18n: 'app.gender.female' },
			{ id: 'other', label: 'Other', i18n: 'app.gender.other' },
			{ id: 'notsay', label: 'Prefer not to say', i18n: 'app.gender.notsay' }
		],
		unitSystems: [
			{ id: 'metric', label: 'Metric', i18n: 'app.unit.metric' },
			{ id: 'imperial', label: 'Imperial', i18n: 'app.unit.imperial' }
		],
		countries: [
			{ id: 'AD', label: 'Andorra', i18n: 'app.countryCode.ad' },
			{ id: 'AE', label: 'United Arab Emirates', i18n: 'app.countryCode.ae' },
			{ id: 'AF', label: 'Afghanistan', i18n: 'app.countryCode.af' },
			{ id: 'AG', label: 'Antigua and Barbuda', i18n: 'app.countryCode.ag' },
			{ id: 'AI', label: 'Anguilla', i18n: 'app.countryCode.ai' },
			{ id: 'AL', label: 'Albania', i18n: 'app.countryCode.al' },
			{ id: 'AM', label: 'Armenia', i18n: 'app.countryCode.am' },
			{ id: 'AN', label: 'Netherlands Antilles', i18n: 'app.countryCode.an' },
			{ id: 'AO', label: 'Angola', i18n: 'app.countryCode.ao' },
			{ id: 'AQ', label: 'Antarctica', i18n: 'app.countryCode.aq' },
			{ id: 'AR', label: 'Argentina', i18n: 'app.countryCode.ar' },
			{ id: 'AS', label: 'American Samoa', i18n: 'app.countryCode.as' },
			{ id: 'AT', label: 'Austria', i18n: 'app.countryCode.at' },
			{ id: 'AU', label: 'Australia', i18n: 'app.countryCode.au' },
			{ id: 'AW', label: 'Aruba', i18n: 'app.countryCode.aw' },
			{ id: 'AZ', label: 'Azerbaijan', i18n: 'app.countryCode.az' },
			{ id: 'BA', label: 'Bosnia and Herzegovina', i18n: 'app.countryCode.ba' },
			{ id: 'BB', label: 'Barbados', i18n: 'app.countryCode.bb' },
			{ id: 'BD', label: 'Bangladesh', i18n: 'app.countryCode.bd' },
			{ id: 'BE', label: 'Belgium', i18n: 'app.countryCode.be' },
			{ id: 'BF', label: 'Burkina Faso', i18n: 'app.countryCode.bf' },
			{ id: 'BG', label: 'Bulgaria', i18n: 'app.countryCode.bg' },
			{ id: 'BH', label: 'Bahrain', i18n: 'app.countryCode.bh' },
			{ id: 'BI', label: 'Burundi', i18n: 'app.countryCode.bi' },
			{ id: 'BJ', label: 'Benin', i18n: 'app.countryCode.bj' },
			{ id: 'BM', label: 'Bermuda', i18n: 'app.countryCode.bm' },
			{ id: 'BN', label: 'Brunei', i18n: 'app.countryCode.bn' },
			{ id: 'BO', label: 'Bolivia', i18n: 'app.countryCode.bo' },
			{ id: 'BR', label: 'Brazil', i18n: 'app.countryCode.br' },
			{ id: 'BS', label: 'Bahamas', i18n: 'app.countryCode.bs' },
			{ id: 'BT', label: 'Bhutan', i18n: 'app.countryCode.bt' },
			{ id: 'BW', label: 'Botswana', i18n: 'app.countryCode.bw' },
			{ id: 'BY', label: 'Belarus', i18n: 'app.countryCode.by' },
			{ id: 'BZ', label: 'Belize', i18n: 'app.countryCode.bz' },
			{ id: 'CA', label: 'Canada', i18n: 'app.countryCode.ca' },
			{ id: 'CC', label: 'Cocos Islands', i18n: 'app.countryCode.cc' },
			{ id: 'CD', label: 'The Democratic Republic Of Congo', i18n: 'app.countryCode.cd' },
			{ id: 'CF', label: 'Central African Republic', i18n: 'app.countryCode.cf' },
			{ id: 'CG', label: 'Congo', i18n: 'app.countryCode.cg' },
			{ id: 'CH', label: 'Switzerland', i18n: 'app.countryCode.ch' },
			{ id: 'CI', label: "Côte d'Ivoire", i18n: 'app.countryCode.ci' },
			{ id: 'CK', label: 'Cook Islands', i18n: 'app.countryCode.ck' },
			{ id: 'CL', label: 'Chile', i18n: 'app.countryCode.cl' },
			{ id: 'CM', label: 'Cameroon', i18n: 'app.countryCode.cm' },
			{ id: 'CN', label: 'China', i18n: 'app.countryCode.cn' },
			{ id: 'CO', label: 'Colombia', i18n: 'app.countryCode.co' },
			{ id: 'CR', label: 'Costa Rica', i18n: 'app.countryCode.cr' },
			{ id: 'CU', label: 'Cuba', i18n: 'app.countryCode.cu' },
			{ id: 'CV', label: 'Cape Verde', i18n: 'app.countryCode.cv' },
			{ id: 'CX', label: 'Christmas Island', i18n: 'app.countryCode.cx' },
			{ id: 'CY', label: 'Cyprus', i18n: 'app.countryCode.cy' },
			{ id: 'CZ', label: 'Czech Republic', i18n: 'app.countryCode.cz' },
			{ id: 'DE', label: 'Germany', i18n: 'app.countryCode.de' },
			{ id: 'DJ', label: 'Djibouti', i18n: 'app.countryCode.dj' },
			{ id: 'DK', label: 'Denmark', i18n: 'app.countryCode.dk' },
			{ id: 'DM', label: 'Dominica', i18n: 'app.countryCode.dm' },
			{ id: 'DO', label: 'Dominican Republic', i18n: 'app.countryCode.do' },
			{ id: 'DZ', label: 'Algeria', i18n: 'app.countryCode.dz' },
			{ id: 'EC', label: 'Ecuador', i18n: 'app.countryCode.ec' },
			{ id: 'EE', label: 'Estonia', i18n: 'app.countryCode.ee' },
			{ id: 'EG', label: 'Egypt', i18n: 'app.countryCode.eg' },
			{ id: 'EH', label: 'Western Sahara', i18n: 'app.countryCode.eh' },
			{ id: 'ER', label: 'Eritrea', i18n: 'app.countryCode.er' },
			{ id: 'ES', label: 'Spain', i18n: 'app.countryCode.es' },
			{ id: 'ET', label: 'Ethiopia', i18n: 'app.countryCode.et' },
			{ id: 'FI', label: 'Finland', i18n: 'app.countryCode.fi' },
			{ id: 'FJ', label: 'Fiji', i18n: 'app.countryCode.fj' },
			{ id: 'FK', label: 'Falkland Islands', i18n: 'app.countryCode.fk' },
			{ id: 'FM', label: 'Micronesia', i18n: 'app.countryCode.fm' },
			{ id: 'FO', label: 'Faroe Islands', i18n: 'app.countryCode.fo' },
			{ id: 'FR', label: 'France', i18n: 'app.countryCode.fr' },
			{ id: 'GA', label: 'Gabon', i18n: 'app.countryCode.ga' },
			{ id: 'GB', label: 'United Kingdom', i18n: 'app.countryCode.gb' },
			{ id: 'GD', label: 'Grenada', i18n: 'app.countryCode.gd' },
			{ id: 'GE', label: 'Georgia', i18n: 'app.countryCode.ge' },
			{ id: 'GF', label: 'French Guiana', i18n: 'app.countryCode.gf' },
			{ id: 'GH', label: 'Ghana', i18n: 'app.countryCode.gh' },
			{ id: 'GI', label: 'Gibraltar', i18n: 'app.countryCode.gi' },
			{ id: 'GL', label: 'Greenland', i18n: 'app.countryCode.gl' },
			{ id: 'GM', label: 'Gambia', i18n: 'app.countryCode.gm' },
			{ id: 'GN', label: 'Guinea', i18n: 'app.countryCode.gn' },
			{ id: 'GP', label: 'Guadeloupe', i18n: 'app.countryCode.gp' },
			{ id: 'GQ', label: 'Equatorial Guinea', i18n: 'app.countryCode.gq' },
			{ id: 'GR', label: 'Greece', i18n: 'app.countryCode.gr' },
			{ id: 'GS', label: 'South Georgia And The South Sandwich Islands', i18n: 'app.countryCode.gs' },
			{ id: 'GT', label: 'Guatemala', i18n: 'app.countryCode.gt' },
			{ id: 'GU', label: 'Guam', i18n: 'app.countryCode.gu' },
			{ id: 'GW', label: 'Guinea-Bissau', i18n: 'app.countryCode.gw' },
			{ id: 'GY', label: 'Guyana', i18n: 'app.countryCode.gy' },
			{ id: 'HK', label: 'Hong Kong', i18n: 'app.countryCode.hk' },
			{ id: 'HN', label: 'Honduras', i18n: 'app.countryCode.hn' },
			{ id: 'HR', label: 'Croatia', i18n: 'app.countryCode.hr' },
			{ id: 'HT', label: 'Haiti', i18n: 'app.countryCode.ht' },
			{ id: 'HU', label: 'Hungary', i18n: 'app.countryCode.hu' },
			{ id: 'ID', label: 'Indonesia', i18n: 'app.countryCode.id' },
			{ id: 'IE', label: 'Ireland', i18n: 'app.countryCode.ie' },
			{ id: 'IL', label: 'Israel', i18n: 'app.countryCode.il' },
			{ id: 'IN', label: 'India', i18n: 'app.countryCode.in' },
			{ id: 'IO', label: 'British Indian Ocean Territory', i18n: 'app.countryCode.io' },
			{ id: 'IQ', label: 'Iraq', i18n: 'app.countryCode.iq' },
			{ id: 'IR', label: 'Iran', i18n: 'app.countryCode.ir' },
			{ id: 'IS', label: 'Iceland', i18n: 'app.countryCode.is' },
			{ id: 'IT', label: 'Italy', i18n: 'app.countryCode.it' },
			{ id: 'JM', label: 'Jamaica', i18n: 'app.countryCode.jm' },
			{ id: 'JO', label: 'Jordan', i18n: 'app.countryCode.jo' },
			{ id: 'JP', label: 'Japan', i18n: 'app.countryCode.jp' },
			{ id: 'KE', label: 'Kenya', i18n: 'app.countryCode.ke' },
			{ id: 'KG', label: 'Kyrgyzstan', i18n: 'app.countryCode.kg' },
			{ id: 'KH', label: 'Cambodia', i18n: 'app.countryCode.kh' },
			{ id: 'KI', label: 'Kiribati', i18n: 'app.countryCode.ki' },
			{ id: 'KM', label: 'Comoros', i18n: 'app.countryCode.km' },
			{ id: 'KN', label: 'Saint Kitts And Nevis', i18n: 'app.countryCode.kn' },
			{ id: 'KP', label: 'North Korea', i18n: 'app.countryCode.kp' },
			{ id: 'KR', label: 'South Korea', i18n: 'app.countryCode.kr' },
			{ id: 'KW', label: 'Kuwait', i18n: 'app.countryCode.kw' },
			{ id: 'KY', label: 'Cayman Islands', i18n: 'app.countryCode.ky' },
			{ id: 'KZ', label: 'Kazakhstan', i18n: 'app.countryCode.kz' },
			{ id: 'LA', label: 'Laos', i18n: 'app.countryCode.la' },
			{ id: 'LB', label: 'Lebanon', i18n: 'app.countryCode.lb' },
			{ id: 'LC', label: 'Saint Lucia', i18n: 'app.countryCode.lc' },
			{ id: 'LI', label: 'Liechtenstein', i18n: 'app.countryCode.li' },
			{ id: 'LK', label: 'Sri Lanka', i18n: 'app.countryCode.lk' },
			{ id: 'LR', label: 'Liberia', i18n: 'app.countryCode.lr' },
			{ id: 'LS', label: 'Lesotho', i18n: 'app.countryCode.ls' },
			{ id: 'LT', label: 'Lithuania', i18n: 'app.countryCode.lt' },
			{ id: 'LU', label: 'Luxembourg', i18n: 'app.countryCode.lu' },
			{ id: 'LV', label: 'Latvia', i18n: 'app.countryCode.lv' },
			{ id: 'LY', label: 'Libya', i18n: 'app.countryCode.ly' },
			{ id: 'MA', label: 'Morocco', i18n: 'app.countryCode.ma' },
			{ id: 'MC', label: 'Monaco', i18n: 'app.countryCode.mc' },
			{ id: 'MD', label: 'Moldova', i18n: 'app.countryCode.md' },
			{ id: 'MG', label: 'Madagascar', i18n: 'app.countryCode.mg' },
			{ id: 'MH', label: 'Marshall Islands', i18n: 'app.countryCode.mh' },
			{ id: 'MK', label: 'Macedonia', i18n: 'app.countryCode.mk' },
			{ id: 'ML', label: 'Mali', i18n: 'app.countryCode.ml' },
			{ id: 'MM', label: 'Myanmar', i18n: 'app.countryCode.mm' },
			{ id: 'MN', label: 'Mongolia', i18n: 'app.countryCode.mn' },
			{ id: 'MO', label: 'Macao', i18n: 'app.countryCode.mo' },
			{ id: 'MP', label: 'Northern Mariana Islands', i18n: 'app.countryCode.mp' },
			{ id: 'MQ', label: 'Martinique', i18n: 'app.countryCode.mq' },
			{ id: 'MR', label: 'Mauritania', i18n: 'app.countryCode.mr' },
			{ id: 'MS', label: 'Montserrat', i18n: 'app.countryCode.ms' },
			{ id: 'MT', label: 'Malta', i18n: 'app.countryCode.mt' },
			{ id: 'MU', label: 'Mauritius', i18n: 'app.countryCode.mu' },
			{ id: 'MV', label: 'Maldives', i18n: 'app.countryCode.mv' },
			{ id: 'MW', label: 'Malawi', i18n: 'app.countryCode.mw' },
			{ id: 'MX', label: 'Mexico', i18n: 'app.countryCode.mx' },
			{ id: 'MY', label: 'Malaysia', i18n: 'app.countryCode.my' },
			{ id: 'MZ', label: 'Mozambique', i18n: 'app.countryCode.mz' },
			{ id: 'NA', label: 'Namibia', i18n: 'app.countryCode.na' },
			{ id: 'NC', label: 'New Caledonia', i18n: 'app.countryCode.nc' },
			{ id: 'NE', label: 'Niger', i18n: 'app.countryCode.ne' },
			{ id: 'NF', label: 'Norfolk Island', i18n: 'app.countryCode.nf' },
			{ id: 'NG', label: 'Nigeria', i18n: 'app.countryCode.ng' },
			{ id: 'NI', label: 'Nicaragua', i18n: 'app.countryCode.ni' },
			{ id: 'NL', label: 'Netherlands', i18n: 'app.countryCode.nl' },
			{ id: 'NO', label: 'Norway', i18n: 'app.countryCode.no' },
			{ id: 'NP', label: 'Nepal', i18n: 'app.countryCode.np' },
			{ id: 'NR', label: 'Nauru', i18n: 'app.countryCode.nr' },
			{ id: 'NU', label: 'Niue', i18n: 'app.countryCode.nu' },
			{ id: 'NZ', label: 'New Zealand', i18n: 'app.countryCode.nz' },
			{ id: 'OM', label: 'Oman', i18n: 'app.countryCode.om' },
			{ id: 'PA', label: 'Panama', i18n: 'app.countryCode.pa' },
			{ id: 'PE', label: 'Peru', i18n: 'app.countryCode.pe' },
			{ id: 'PF', label: 'French Polynesia', i18n: 'app.countryCode.pf' },
			{ id: 'PG', label: 'Papua New Guinea', i18n: 'app.countryCode.pg' },
			{ id: 'PH', label: 'Philippines', i18n: 'app.countryCode.ph' },
			{ id: 'PK', label: 'Pakistan', i18n: 'app.countryCode.pk' },
			{ id: 'PL', label: 'Poland', i18n: 'app.countryCode.pl' },
			{ id: 'PM', label: 'Saint Pierre And Miquelon', i18n: 'app.countryCode.pm' },
			{ id: 'PN', label: 'Pitcairn', i18n: 'app.countryCode.pn' },
			{ id: 'PR', label: 'Puerto Rico', i18n: 'app.countryCode.pr' },
			{ id: 'PS', label: 'Palestine', i18n: 'app.countryCode.ps' },
			{ id: 'PT', label: 'Portugal', i18n: 'app.countryCode.pt' },
			{ id: 'PW', label: 'Palau', i18n: 'app.countryCode.pw' },
			{ id: 'PY', label: 'Paraguay', i18n: 'app.countryCode.py' },
			{ id: 'QA', label: 'Qatar', i18n: 'app.countryCode.qa' },
			{ id: 'RE', label: 'Reunion', i18n: 'app.countryCode.re' },
			{ id: 'RO', label: 'Romania', i18n: 'app.countryCode.ro' },
			{ id: 'RU', label: 'Russia', i18n: 'app.countryCode.ru' },
			{ id: 'RW', label: 'Rwanda', i18n: 'app.countryCode.rw' },
			{ id: 'SA', label: 'Saudi Arabia', i18n: 'app.countryCode.sa' },
			{ id: 'SB', label: 'Solomon Islands', i18n: 'app.countryCode.sb' },
			{ id: 'SC', label: 'Seychelles', i18n: 'app.countryCode.sc' },
			{ id: 'SD', label: 'Sudan', i18n: 'app.countryCode.sd' },
			{ id: 'SE', label: 'Sweden', i18n: 'app.countryCode.se' },
			{ id: 'SG', label: 'Singapore', i18n: 'app.countryCode.sg' },
			{ id: 'SH', label: 'Saint Helena', i18n: 'app.countryCode.sh' },
			{ id: 'SI', label: 'Slovenia', i18n: 'app.countryCode.si' },
			{ id: 'SJ', label: 'Svalbard And Jan Mayen', i18n: 'app.countryCode.sj' },
			{ id: 'SK', label: 'Slovakia', i18n: 'app.countryCode.sk' },
			{ id: 'SL', label: 'Sierra Leone', i18n: 'app.countryCode.sl' },
			{ id: 'SM', label: 'San Marino', i18n: 'app.countryCode.sm' },
			{ id: 'SN', label: 'Senegal', i18n: 'app.countryCode.sn' },
			{ id: 'SO', label: 'Somalia', i18n: 'app.countryCode.so' },
			{ id: 'SR', label: 'Suriname', i18n: 'app.countryCode.sr' },
			{ id: 'ST', label: 'Sao Tome And Principe', i18n: 'app.countryCode.st' },
			{ id: 'SV', label: 'El Salvador', i18n: 'app.countryCode.sv' },
			{ id: 'SY', label: 'Syria', i18n: 'app.countryCode.sy' },
			{ id: 'SZ', label: 'Swaziland', i18n: 'app.countryCode.sz' },
			{ id: 'TC', label: 'Turks And Caicos Islands', i18n: 'app.countryCode.tc' },
			{ id: 'TD', label: 'Chad', i18n: 'app.countryCode.td' },
			{ id: 'TF', label: 'French Southern Territories', i18n: 'app.countryCode.tf' },
			{ id: 'TG', label: 'Togo', i18n: 'app.countryCode.tg' },
			{ id: 'TH', label: 'Thailand', i18n: 'app.countryCode.th' },
			{ id: 'TJ', label: 'Tajikistan', i18n: 'app.countryCode.tj' },
			{ id: 'TK', label: 'Tokelau', i18n: 'app.countryCode.tk' },
			{ id: 'TL', label: 'Timor-Leste', i18n: 'app.countryCode.tl' },
			{ id: 'TM', label: 'Turkmenistan', i18n: 'app.countryCode.tm' },
			{ id: 'TN', label: 'Tunisia', i18n: 'app.countryCode.tn' },
			{ id: 'TO', label: 'Tonga', i18n: 'app.countryCode.to' },
			{ id: 'TR', label: 'Turkey', i18n: 'app.countryCode.tr' },
			{ id: 'TT', label: 'Trinidad and Tobago', i18n: 'app.countryCode.tt' },
			{ id: 'TV', label: 'Tuvalu', i18n: 'app.countryCode.tv' },
			{ id: 'TW', label: 'Taiwan', i18n: 'app.countryCode.tw' },
			{ id: 'TZ', label: 'Tanzania', i18n: 'app.countryCode.tz' },
			{ id: 'UA', label: 'Ukraine', i18n: 'app.countryCode.ua' },
			{ id: 'UG', label: 'Uganda', i18n: 'app.countryCode.ug' },
			{ id: 'UM', label: 'United States Minor Outlying Islands', i18n: 'app.countryCode.um' },
			{ id: 'US', label: 'United States', i18n: 'app.countryCode.us' },
			{ id: 'UY', label: 'Uruguay', i18n: 'app.countryCode.uy' },
			{ id: 'UZ', label: 'Uzbekistan', i18n: 'app.countryCode.uz' },
			{ id: 'VA', label: 'Vatican', i18n: 'app.countryCode.va' },
			{ id: 'VC', label: 'Saint Vincent And The Grenadines', i18n: 'app.countryCode.vc' },
			{ id: 'VE', label: 'Venezuela', i18n: 'app.countryCode.ve' },
			{ id: 'VG', label: 'British Virgin Islands', i18n: 'app.countryCode.vg' },
			{ id: 'VI', label: 'U.S. Virgin Islands', i18n: 'app.countryCode.vi' },
			{ id: 'VN', label: 'Vietnam', i18n: 'app.countryCode.vn' },
			{ id: 'VU', label: 'Vanuatu', i18n: 'app.countryCode.vu' },
			{ id: 'WF', label: 'Wallis And Futuna', i18n: 'app.countryCode.wf' },
			{ id: 'WS', label: 'Samoa', i18n: 'app.countryCode.ws' },
			{ id: 'YE', label: 'Yemen', i18n: 'app.countryCode.ye' },
			{ id: 'YT', label: 'Mayotte', i18n: 'app.countryCode.yt' },
			{ id: 'ZA', label: 'South Africa', i18n: 'app.countryCode.za' },
			{ id: 'ZM', label: 'Zambia', i18n: 'app.countryCode.zm' },
			{ id: 'ZW', label: 'Zimbabwe', i18n: 'app.countryCode.zw' },
			{ id: 'ME', label: 'Montenegro', i18n: 'app.countryCode.me' },
			{ id: 'RS', label: 'Serbia', i18n: 'app.countryCode.rs' },
			{ id: 'JE', label: 'Jersey', i18n: 'app.countryCode.je' },
			{ id: 'BQ', label: 'Bonaire, Sint Eustatius and Saba', i18n: 'app.countryCode.bq' },
			{ id: 'IM', label: 'Isle Of Man', i18n: 'app.countryCode.im' },
			{ id: 'AX', label: 'Åland Islands', i18n: 'app.countryCode.ax' },
			{ id: 'BV', label: 'Bouvet Island', i18n: 'app.countryCode.bv' },
			{ id: 'CW', label: 'Curaçao', i18n: 'app.countryCode.cw' },
			{ id: 'GG', label: 'Guernsey', i18n: 'app.countryCode.gg' },
			{ id: 'HM', label: 'Heard Island And McDonald Islands', i18n: 'app.countryCode.hm' },
			{ id: 'BL', label: 'Saint Barthélemy', i18n: 'app.countryCode.bl' },
			{ id: 'MF', label: 'Saint Martin', i18n: 'app.countryCode.mf' },
			{ id: 'SX', label: 'Saint Maarten (Dutch part)', i18n: 'app.countryCode.sx' },
			{ id: 'SS', label: 'South Sudan', i18n: 'app.countryCode.ss' }
		],
		countryCodes: [
			{ id: '+1', label: 'United States', i18n: 'app.countryCode.us' },
			{ id: '+44', label: 'United Kingdom', i18n: 'app.countryCode.gb' },
			{ id: '+61', label: 'Australia', i18n: 'app.countryCode.au' },
			{ id: '+93', label: 'Afghanistan (‫افغانستان‬‎)', i18n: 'app.countryCode.af' },
			{ id: '+358', label: 'Åland Islands', i18n: 'app.countryCode.ax' },
			{ id: '+355', label: 'Albania (Shqipëri)', i18n: 'app.countryCode.al' },
			{ id: '+213', label: 'Algeria (‫الجزائر‬‎)', i18n: 'app.countryCode.dz' },
			{ id: '+1684', label: 'American Samoa', i18n: 'app.countryCode.as' },
			{ id: '+376', label: 'Andorra', i18n: 'app.countryCode.ad' },
			{ id: '+244', label: 'Angola', i18n: 'app.countryCode.ao' },
			{ id: '+1264', label: 'Anguilla', i18n: 'app.countryCode.ai' },
			{ id: '+1268', label: 'Antigua and Barbuda', i18n: 'app.countryCode.ag' },
			{ id: '+54', label: 'Argentina', i18n: 'app.countryCode.ar' },
			{ id: '+374', label: 'Armenia (Հայաստան)', i18n: 'app.countryCode.am' },
			{ id: '+297', label: 'Aruba', i18n: 'app.countryCode.aw' },
			{ id: '+43', label: 'Austria (Österreich)', i18n: 'app.countryCode.at' },
			{ id: '+994', label: 'Azerbaijan (Azərbaycan)', i18n: 'app.countryCode.az' },
			{ id: '+1242', label: 'Bahamas', i18n: 'app.countryCode.bs' },
			{ id: '+973', label: 'Bahrain (‫البحرين‬‎)', i18n: 'app.countryCode.bh' },
			{ id: '+880', label: 'Bangladesh (বাংলাদেশ)', i18n: 'app.countryCode.bd' },
			{ id: '+1246', label: 'Barbados', i18n: 'app.countryCode.bb' },
			{ id: '+375', label: 'Belarus (Беларусь)', i18n: 'app.countryCode.by' },
			{ id: '+32', label: 'Belgium (België)', i18n: 'app.countryCode.be' },
			{ id: '+501', label: 'Belize', i18n: 'app.countryCode.bz' },
			{ id: '+229', label: 'Benin (Bénin)', i18n: 'app.countryCode.bj' },
			{ id: '+1441', label: 'Bermuda', i18n: 'app.countryCode.bm' },
			{ id: '+975', label: 'Bhutan (འབྲུག)', i18n: 'app.countryCode.bt' },
			{ id: '+591', label: 'Bolivia', i18n: 'app.countryCode.bo' },
			{
				id: '+387',
				label: 'Bosnia and Herzegovina (Босна и Херцеговина)',
				i18n: 'app.countryCode.ba'
			},
			{ id: '+267', label: 'Botswana', i18n: 'app.countryCode.bw' },
			{ id: '+55', label: 'Brazil (Brasil)', i18n: 'app.countryCode.br' },
			{ id: '+246', label: 'British Indian Ocean Territory', i18n: 'app.countryCode.io' },
			{ id: '+1284', label: 'British Virgin Islands', i18n: 'app.countryCode.vg' },
			{ id: '+673', label: 'Brunei', i18n: 'app.countryCode.bn' },
			{ id: '+359', label: 'Bulgaria (България)', i18n: 'app.countryCode.bg' },
			{ id: '+226', label: 'Burkina Faso', i18n: 'app.countryCode.bf' },
			{ id: '+257', label: 'Burundi (Uburundi)', i18n: 'app.countryCode.bi' },
			{ id: '+855', label: 'Cambodia (កម្ពុជា)', i18n: 'app.countryCode.kh' },
			{ id: '+237', label: 'Cameroon (Cameroun)', i18n: 'app.countryCode.cm' },
			{ id: '+1', label: 'Canada', i18n: 'app.countryCode.ca' },
			{ id: '+238', label: 'Cape Verde (Kabu Verdi)', i18n: 'app.countryCode.cv' },
			{ id: '+599', label: 'Caribbean Netherlands', i18n: 'app.countryCode.bq' },
			{ id: '+1345', label: 'Cayman Islands', i18n: 'app.countryCode.ky' },
			{
				id: '+236',
				label: 'Central African Republic (République centrafricaine)',
				i18n: 'app.countryCode.cf'
			},
			{ id: '+235', label: 'Chad (Tchad)', i18n: 'app.countryCode.td' },
			{ id: '+56', label: 'Chile', i18n: 'app.countryCode.cl' },
			{ id: '+86', label: 'China (中国)', i18n: 'app.countryCode.cn' },
			{ id: '+61', label: 'Christmas Island', i18n: 'app.countryCode.cx' },
			{ id: '+61', label: 'Cocos (Keeling) Islands', i18n: 'app.countryCode.cc' },
			{ id: '+57', label: 'Colombia', i18n: 'app.countryCode.co' },
			{ id: '+269', label: 'Comoros (‫جزر القمر‬‎)', i18n: 'app.countryCode.km' },
			{
				id: '+243',
				label: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
				i18n: 'app.countryCode.cd'
			},
			{
				id: '+242',
				label: 'Congo (Republic) (Congo-Brazzaville)',
				i18n: 'app.countryCode.cg'
			},
			{ id: '+682', label: 'Cook Islands', i18n: 'app.countryCode.ck' },
			{ id: '+506', label: 'Costa Rica', i18n: 'app.countryCode.cr' },
			{ id: '+225', label: 'Côte d’Ivoire', i18n: 'app.countryCode.ci' },
			{ id: '+385', label: 'Croatia (Hrvatska)', i18n: 'app.countryCode.hr' },
			{ id: '+53', label: 'Cuba', i18n: 'app.countryCode.cu' },
			{ id: '+599', label: 'Curaçao', i18n: 'app.countryCode.cw' },
			{ id: '+357', label: 'Cyprus (Κύπρος)', i18n: 'app.countryCode.cy' },
			{ id: '+420', label: 'Czech Republic (Česká republika)', i18n: 'app.countryCode.cz' },
			{ id: '+45', label: 'Denmark (Danmark)', i18n: 'app.countryCode.dk' },
			{ id: '+253', label: 'Djibouti', i18n: 'app.countryCode.dj' },
			{ id: '+1767', label: 'Dominica', i18n: 'app.countryCode.dm' },
			{
				id: '+1',
				label: 'Dominican Republic (República Dominicana)',
				i18n: 'app.countryCode.do'
			},
			{ id: '+593', label: 'Ecuador', i18n: 'app.countryCode.ec' },
			{ id: '+20', label: 'Egypt (‫مصر‬‎)', i18n: 'app.countryCode.eg' },
			{ id: '+503', label: 'El Salvador', i18n: 'app.countryCode.sv' },
			{
				id: '+240',
				label: 'Equatorial Guinea (Guinea Ecuatorial)',
				i18n: 'app.countryCode.gq'
			},
			{ id: '+291', label: 'Eritrea', i18n: 'app.countryCode.er' },
			{ id: '+372', label: 'Estonia (Eesti)', i18n: 'app.countryCode.ee' },
			{ id: '+251', label: 'Ethiopia', i18n: 'app.countryCode.et' },
			{ id: '+500', label: 'Falkland Islands (Islas Malvinas)', i18n: 'app.countryCode.fk' },
			{ id: '+298', label: 'Faroe Islands (Føroyar)', i18n: 'app.countryCode.fo' },
			{ id: '+679', label: 'Fiji', i18n: 'app.countryCode.fj' },
			{ id: '+358', label: 'Finland (Suomi)', i18n: 'app.countryCode.fi' },
			{ id: '+33', label: 'France', i18n: 'app.countryCode.fr' },
			{ id: '+594', label: 'French Guiana (Guyane française)', i18n: 'app.countryCode.gf' },
			{
				id: '+689',
				label: 'French Polynesia (Polynésie française)',
				i18n: 'app.countryCode.pf'
			},
			{ id: '+241', label: 'Gabon', i18n: 'app.countryCode.ga' },
			{ id: '+220', label: 'Gambia', i18n: 'app.countryCode.gm' },
			{ id: '+995', label: 'Georgia (საქართველო)', i18n: 'app.countryCode.ge' },
			{ id: '+49', label: 'Germany (Deutschland)', i18n: 'app.countryCode.de' },
			{ id: '+233', label: 'Ghana (Gaana)', i18n: 'app.countryCode.gh' },
			{ id: '+350', label: 'Gibraltar', i18n: 'app.countryCode.gi' },
			{ id: '+30', label: 'Greece (Ελλάδα)', i18n: 'app.countryCode.gr' },
			{ id: '+299', label: 'Greenland (Kalaallit Nunaat)', i18n: 'app.countryCode.gl' },
			{ id: '+1473', label: 'Grenada', i18n: 'app.countryCode.gd' },
			{ id: '+590', label: 'Guadeloupe', i18n: 'app.countryCode.gp' },
			{ id: '+1671', label: 'Guam', i18n: 'app.countryCode.gu' },
			{ id: '+502', label: 'Guatemala', i18n: 'app.countryCode.gt' },
			{ id: '+44', label: 'Guernsey', i18n: 'app.countryCode.gg' },
			{ id: '+224', label: 'Guinea (Guinée)', i18n: 'app.countryCode.gn' },
			{ id: '+245', label: 'Guinea-Bissau (Guiné Bissau)', i18n: 'app.countryCode.gw' },
			{ id: '+592', label: 'Guyana', i18n: 'app.countryCode.gy' },
			{ id: '+509', label: 'Haiti', i18n: 'app.countryCode.ht' },
			{ id: '+504', label: 'Honduras', i18n: 'app.countryCode.hn' },
			{ id: '+852', label: 'Hong Kong (香港)', i18n: 'app.countryCode.hk' },
			{ id: '+36', label: 'Hungary (Magyarország)', i18n: 'app.countryCode.hu' },
			{ id: '+354', label: 'Iceland (Ísland)', i18n: 'app.countryCode.is' },
			{ id: '+91', label: 'India (भारत)', i18n: 'app.countryCode.in' },
			{ id: '+62', label: 'Indonesia', i18n: 'app.countryCode.id' },
			{ id: '+98', label: 'Iran (‫ایران‬‎)', i18n: 'app.countryCode.ir' },
			{ id: '+964', label: 'Iraq (‫العراق‬‎)', i18n: 'app.countryCode.iq' },
			{ id: '+353', label: 'Ireland', i18n: 'app.countryCode.ie' },
			{ id: '+44', label: 'Isle of Man', i18n: 'app.countryCode.im' },
			{ id: '+972', label: 'Israel (‫ישראל‬‎)', i18n: 'app.countryCode.il' },
			{ id: '+39', label: 'Italy (Italia)', i18n: 'app.countryCode.it' },
			{ id: '+1', label: 'Jamaica', i18n: 'app.countryCode.jm' },
			{ id: '+81', label: 'Japan (日本)', i18n: 'app.countryCode.jp' },
			{ id: '+44', label: 'Jersey', i18n: 'app.countryCode.je' },
			{ id: '+962', label: 'Jordan (‫الأردن‬‎)', i18n: 'app.countryCode.jo' },
			{ id: '+7', label: 'Kazakhstan (Казахстан)', i18n: 'app.countryCode.kz' },
			{ id: '+254', label: 'Kenya', i18n: 'app.countryCode.ke' },
			{ id: '+686', label: 'Kiribati', i18n: 'app.countryCode.ki' },
			{ id: '+383', label: 'Kosovo', i18n: 'app.countryCode.xk' },
			{ id: '+965', label: 'Kuwait (‫الكويت‬‎)', i18n: 'app.countryCode.kw' },
			{ id: '+996', label: 'Kyrgyzstan (Кыргызстан)', i18n: 'app.countryCode.kg' },
			{ id: '+856', label: 'Laos (ລາວ)', i18n: 'app.countryCode.la' },
			{ id: '+371', label: 'Latvia (Latvija)', i18n: 'app.countryCode.lv' },
			{ id: '+961', label: 'Lebanon (‫لبنان‬‎)', i18n: 'app.countryCode.lb' },
			{ id: '+266', label: 'Lesotho', i18n: 'app.countryCode.ls' },
			{ id: '+231', label: 'Liberia', i18n: 'app.countryCode.lr' },
			{ id: '+218', label: 'Libya (‫ليبيا‬‎)', i18n: 'app.countryCode.ly' },
			{ id: '+423', label: 'Liechtenstein', i18n: 'app.countryCode.li' },
			{ id: '+370', label: 'Lithuania (Lietuva)', i18n: 'app.countryCode.lt' },
			{ id: '+352', label: 'Luxembourg', i18n: 'app.countryCode.lu' },
			{ id: '+853', label: 'Macau (澳門)', i18n: 'app.countryCode.mo' },
			{ id: '+389', label: 'Macedonia (FYROM) (Македонија)', i18n: 'app.countryCode.mk' },
			{ id: '+261', label: 'Madagascar (Madagasikara)', i18n: 'app.countryCode.mg' },
			{ id: '+265', label: 'Malawi', i18n: 'app.countryCode.mw' },
			{ id: '+60', label: 'Malaysia', i18n: 'app.countryCode.my' },
			{ id: '+960', label: 'Maldives', i18n: 'app.countryCode.mv' },
			{ id: '+223', label: 'Mali', i18n: 'app.countryCode.ml' },
			{ id: '+356', label: 'Malta', i18n: 'app.countryCode.mt' },
			{ id: '+692', label: 'Marshall Islands', i18n: 'app.countryCode.mh' },
			{ id: '+596', label: 'Martinique', i18n: 'app.countryCode.mq' },
			{ id: '+222', label: 'Mauritania (‫موريتانيا‬‎)', i18n: 'app.countryCode.mr' },
			{ id: '+230', label: 'Mauritius (Moris)', i18n: 'app.countryCode.mu' },
			{ id: '+262', label: 'Mayotte', i18n: 'app.countryCode.yt' },
			{ id: '+52', label: 'Mexico (México)', i18n: 'app.countryCode.mx' },
			{ id: '+691', label: 'Micronesia', i18n: 'app.countryCode.fm' },
			{ id: '+373', label: 'Moldova (Republica Moldova)', i18n: 'app.countryCode.md' },
			{ id: '+377', label: 'Monaco', i18n: 'app.countryCode.mc' },
			{ id: '+976', label: 'Mongolia (Монгол)', i18n: 'app.countryCode.mn' },
			{ id: '+382', label: 'Montenegro (Crna Gora)', i18n: 'app.countryCode.me' },
			{ id: '+1664', label: 'Montserrat', i18n: 'app.countryCode.ms' },
			{ id: '+212', label: 'Morocco (‫المغرب‬‎)', i18n: 'app.countryCode.ma' },
			{ id: '+258', label: 'Mozambique (Moçambique)', i18n: 'app.countryCode.mz' },
			{ id: '+95', label: 'Myanmar (Burma) (မြန်မာ)', i18n: 'app.countryCode.mm' },
			{ id: '+264', label: 'Namibia (Namibië)', i18n: 'app.countryCode.na' },
			{ id: '+674', label: 'Nauru', i18n: 'app.countryCode.nr' },
			{ id: '+977', label: 'Nepal (नेपाल)', i18n: 'app.countryCode.np' },
			{ id: '+31', label: 'Netherlands (Nederland)', i18n: 'app.countryCode.nl' },
			{ id: '+687', label: 'New Caledonia (Nouvelle-Calédonie)', i18n: 'app.countryCode.nc' },
			{ id: '+64', label: 'New Zealand', i18n: 'app.countryCode.nz' },
			{ id: '+505', label: 'Nicaragua', i18n: 'app.countryCode.ni' },
			{ id: '+227', label: 'Niger (Nijar)', i18n: 'app.countryCode.ne' },
			{ id: '+234', label: 'Nigeria', i18n: 'app.countryCode.ng' },
			{ id: '+683', label: 'Niue', i18n: 'app.countryCode.nu' },
			{ id: '+672', label: 'Norfolk Island', i18n: 'app.countryCode.nf' },
			{
				id: '+850',
				label: 'North Korea (조선 민주주의 인민 공화국)',
				i18n: 'app.countryCode.kp'
			},
			{ id: '+1670', label: 'Northern Mariana Islands', i18n: 'app.countryCode.mp' },
			{ id: '+47', label: 'Norway (Norge)', i18n: 'app.countryCode.no' },
			{ id: '+968', label: 'Oman (‫عُمان‬‎)', i18n: 'app.countryCode.om' },
			{ id: '+92', label: 'Pakistan (‫پاکستان‬‎)', i18n: 'app.countryCode.pk' },
			{ id: '+680', label: 'Palau', i18n: 'app.countryCode.pw' },
			{ id: '+970', label: 'Palestine (‫فلسطين‬‎)', i18n: 'app.countryCode.ps' },
			{ id: '+507', label: 'Panama (Panamá)', i18n: 'app.countryCode.pa' },
			{ id: '+675', label: 'Papua New Guinea', i18n: 'app.countryCode.pg' },
			{ id: '+595', label: 'Paraguay', i18n: 'app.countryCode.py' },
			{ id: '+51', label: 'Peru (Perú)', i18n: 'app.countryCode.pe' },
			{ id: '+63', label: 'Philippines', i18n: 'app.countryCode.ph' },
			{ id: '+48', label: 'Poland (Polska)', i18n: 'app.countryCode.pl' },
			{ id: '+351', label: 'Portugal', i18n: 'app.countryCode.pt' },
			{ id: '+1', label: 'Puerto Rico', i18n: 'app.countryCode.pr' },
			{ id: '+974', label: 'Qatar (‫قطر‬‎)', i18n: 'app.countryCode.qa' },
			{ id: '+262', label: 'Réunion (La Réunion)', i18n: 'app.countryCode.re' },
			{ id: '+40', label: 'Romania (România)', i18n: 'app.countryCode.ro' },
			{ id: '+7', label: 'Russia (Россия)', i18n: 'app.countryCode.ru' },
			{ id: '+250', label: 'Rwanda', i18n: 'app.countryCode.rw' },
			{ id: '+590', label: 'Saint Barthélemy', i18n: 'app.countryCode.bl' },
			{ id: '+290', label: 'Saint Helena', i18n: 'app.countryCode.sh' },
			{ id: '+1869', label: 'Saint Kitts and Nevis', i18n: 'app.countryCode.kn' },
			{ id: '+1758', label: 'Saint Lucia', i18n: 'app.countryCode.lc' },
			{
				id: '+590',
				label: 'Saint Martin (Saint-Martin (partie française))',
				i18n: 'app.countryCode.mf'
			},
			{
				id: '+508',
				label: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
				i18n: 'app.countryCode.pm'
			},
			{ id: '+1784', label: 'Saint Vincent and the Grenadines', i18n: 'app.countryCode.vc' },
			{ id: '+685', label: 'Samoa', i18n: 'app.countryCode.ws' },
			{ id: '+378', label: 'San Marino', i18n: 'app.countryCode.sm' },
			{
				id: '+239',
				label: 'São Tomé and Príncipe (São Tomé e Príncipe)',
				i18n: 'app.countryCode.st'
			},
			{
				id: '+966',
				label: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
				i18n: 'app.countryCode.sa'
			},
			{ id: '+221', label: 'Senegal (Sénégal)', i18n: 'app.countryCode.sn' },
			{ id: '+381', label: 'Serbia (Србија)', i18n: 'app.countryCode.rs' },
			{ id: '+248', label: 'Seychelles', i18n: 'app.countryCode.sc' },
			{ id: '+232', label: 'Sierra Leone', i18n: 'app.countryCode.sl' },
			{ id: '+65', label: 'Singapore', i18n: 'app.countryCode.sg' },
			{ id: '+1721', label: 'Sint Maarten', i18n: 'app.countryCode.sx' },
			{ id: '+421', label: 'Slovakia (Slovensko)', i18n: 'app.countryCode.sk' },
			{ id: '+386', label: 'Slovenia (Slovenija)', i18n: 'app.countryCode.si' },
			{ id: '+677', label: 'Solomon Islands', i18n: 'app.countryCode.sb' },
			{ id: '+252', label: 'Somalia (Soomaaliya)', i18n: 'app.countryCode.so' },
			{ id: '+27', label: 'South Africa', i18n: 'app.countryCode.za' },
			{ id: '+82', label: 'South Korea (대한민국)', i18n: 'app.countryCode.kr' },
			{ id: '+211', label: 'South Sudan (‫جنوب السودان‬‎)', i18n: 'app.countryCode.ss' },
			{ id: '+34', label: 'Spain (España)', i18n: 'app.countryCode.es' },
			{ id: '+94', label: 'Sri Lanka (ශ්‍රී ලංකාව)', i18n: 'app.countryCode.lk' },
			{ id: '+249', label: 'Sudan (‫السودان‬‎)', i18n: 'app.countryCode.sd' },
			{ id: '+597', label: 'Suriname', i18n: 'app.countryCode.sr' },
			{ id: '+47', label: 'Svalbard and Jan Mayen', i18n: 'app.countryCode.sj' },
			{ id: '+268', label: 'Swaziland', i18n: 'app.countryCode.sz' },
			{ id: '+46', label: 'Sweden (Sverige)', i18n: 'app.countryCode.se' },
			{ id: '+41', label: 'Switzerland (Schweiz)', i18n: 'app.countryCode.ch' },
			{ id: '+963', label: 'Syria (‫سوريا‬‎)', i18n: 'app.countryCode.sy' },
			{ id: '+886', label: 'Taiwan (台灣)', i18n: 'app.countryCode.tw' },
			{ id: '+992', label: 'Tajikistan', i18n: 'app.countryCode.tj' },
			{ id: '+255', label: 'Tanzania', i18n: 'app.countryCode.tz' },
			{ id: '+66', label: 'Thailand (ไทย)', i18n: 'app.countryCode.th' },
			{ id: '+670', label: 'Timor-Leste', i18n: 'app.countryCode.tl' },
			{ id: '+228', label: 'Togo', i18n: 'app.countryCode.tg' },
			{ id: '+690', label: 'Tokelau', i18n: 'app.countryCode.tk' },
			{ id: '+676', label: 'Tonga', i18n: 'app.countryCode.to' },
			{ id: '+1868', label: 'Trinidad and Tobago', i18n: 'app.countryCode.tt' },
			{ id: '+216', label: 'Tunisia (‫تونس‬‎)', i18n: 'app.countryCode.tn' },
			{ id: '+90', label: 'Turkey (Türkiye)', i18n: 'app.countryCode.tr' },
			{ id: '+993', label: 'Turkmenistan', i18n: 'app.countryCode.tm' },
			{ id: '+1649', label: 'Turks and Caicos Islands', i18n: 'app.countryCode.tc' },
			{ id: '+688', label: 'Tuvalu', i18n: 'app.countryCode.tv' },
			{ id: '+1340', label: 'U.S. Virgin Islands', i18n: 'app.countryCode.vi' },
			{ id: '+256', label: 'Uganda', i18n: 'app.countryCode.ug' },
			{ id: '+380', label: 'Ukraine (Україна)', i18n: 'app.countryCode.ua' },
			{
				id: '+971',
				label: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
				i18n: 'app.countryCode.ae'
			},
			{ id: '+598', label: 'Uruguay', i18n: 'app.countryCode.uy' },
			{ id: '+998', label: 'Uzbekistan (Oʻzbekiston)', i18n: 'app.countryCode.uz' },
			{ id: '+678', label: 'Vanuatu', i18n: 'app.countryCode.vu' },
			{ id: '+39', label: 'Vatican City (Città del Vaticano)', i18n: 'app.countryCode.va' },
			{ id: '+58', label: 'Venezuela', i18n: 'app.countryCode.ve' },
			{ id: '+84', label: 'Vietnam (Việt Nam)', i18n: 'app.countryCode.vn' },
			{
				id: '+681',
				label: 'Wallis and Futuna (Wallis-et-Futuna)',
				i18n: 'app.countryCode.wf'
			},
			{
				id: '+212',
				label: 'Western Sahara (‫الصحراء الغربية‬‎)',
				i18n: 'app.countryCode.eh'
			},
			{ id: '+967', label: 'Yemen (‫اليمن‬‎)', i18n: 'app.countryCode.ye' },
			{ id: '+260', label: 'Zambia', i18n: 'app.countryCode.zm' },
			{ id: '+263', label: 'Zimbabwe', i18n: 'app.countryCode.zw' }
		],
		errors: [
			{ id: 401, label: 'Unauthorized', i18n: '' },
			{ id: 500, label: 'Server error', i18n: '' }
		]
	};

	constructor(private i18nService: I18nService) {}

	public has(type: string, id: string): boolean {
		for (let i = 0; i < this.strings[type].length; i++) {
			if (this.strings[type][i].id.toLowerCase() === id.toLowerCase()) {
				return true;
			}
		}

		return false;
	}

	public get(type: string, id?: string): any {
		if (!type || type === '') {
			return id || '';
		}

		let str: any[] = this.strings[type];
		if (id) {
			const element: any = str.find((field: any) => field.id === id.toLowerCase());
			if (element) {
				const source = element.label;
				return this.i18nService.get(source, element.i18n);
			}
		} else {
			str = [...this.strings[type]];

			str.forEach((obj, idx) => {
				if (obj.label && obj.i18n) {
					str[idx].label = this.i18nService.get(obj.label, obj.i18n);
				}
			});

			return str;
		}
		return '';
	}

	public getByLabel(label: string = ''): string {
		const src: any = this.strings;
		let str = label;
		for (const key in src) {
			if (key) {
				const elements: any[] = src[key];
				elements.forEach((element) => {
					if (element.label === label) {
						str = this.get(key, element.id);
					}
				});
			}
		}
		return str;
	}
}
